module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-welcome-background-chevy.6364acea.png";